import { UserIcon } from '@mote/assets/icons'
import {
  StyledAnonymousAvatar,
  getAnonymousAvatarIconsSize
} from './AnonymouseAvatar.styles'
import type { AvatarSize } from './Common.styles'

export interface AnonymousAvatarProps {
  bordered?: boolean | number
  size: AvatarSize
}

export function AnonymousAvatar(props: AnonymousAvatarProps): JSX.Element {
  return (
    <StyledAnonymousAvatar size={props.size} bordered={props.bordered}>
      <UserIcon
        width={getAnonymousAvatarIconsSize(props.size)}
        height={getAnonymousAvatarIconsSize(props.size)}
      />
    </StyledAnonymousAvatar>
  )
}
